const productTabHeaders = document.querySelectorAll('[js-product-tab-header]');
const productTabContents= document.querySelectorAll('[js-product-tab-content]');
const productTabToggle = document.querySelector('[js-product-tab-toggle]');
const productTabMenu = document.querySelector('[js-product-tab-menu]');
const productTabOptions = document.querySelectorAll('[js-product-tab-option]');
const productTabCurrent = document.querySelector('[js-product-tab-current]');
if (productTabHeaders.length && productTabContents.length) {
  const closeDropdown = () => {
    if (productTabToggle && productTabMenu) {
      productTabToggle.setAttribute('aria-expanded', 'false');
      productTabMenu.hidden = true;
    }
  };

  const setActiveTab = (index) => {
    productTabHeaders.forEach((th, headerIndex) => th.classList.toggle('active', headerIndex === index));
    productTabContents.forEach((tc, contentIndex) => tc.classList.toggle('active', contentIndex === index));
    if (productTabCurrent && productTabOptions[index]) {
      productTabCurrent.innerHTML = productTabOptions[index].innerHTML;
    }
       productTabOptions.forEach((option, optionIndex) => {
      option.hidden = optionIndex === index;
    });
    closeDropdown();
  };

  setActiveTab(0);

  productTabHeaders.forEach((tab,index)=>{
    tab.addEventListener('click',()=>{
      setActiveTab(index);
    })
  })

  productTabOptions.forEach((option) => {
    option.addEventListener('click', () => {
      setActiveTab(Number(option.dataset.tabIndex));
    });
  });

  if (productTabToggle && productTabMenu) {
    productTabToggle.addEventListener('click', () => {
      const isExpanded = productTabToggle.getAttribute('aria-expanded') === 'true';
      productTabToggle.setAttribute('aria-expanded', String(!isExpanded));
      productTabMenu.hidden = isExpanded;
    });

    document.addEventListener('click', (event) => {
      if (!productTabToggle.closest('.tabs-dropdown').contains(event.target)) {
        closeDropdown();
      }
    });
  }
}
